<!-- NEW DESIGN: START -->
<!-- NEW DESIGN: START -->
<span *ngIf="newDesign && event">
  <!-- Generated template for the EventSearchListItemComponent component -->
  <ion-button
    class="align transparent-btn"
    (click)="openEventDetails()"
    *ngIf="!secondEntryLevel || openDetails"
  >
    <!-- Avatar with Date -->
    <ion-avatar
      slot="start"
      class="avatar"
      [ngClass]="order % 2 === 0 ? 'even' : 'odd'"
      style="margin-right: 8px;"
    >
      <div class="date-range date-range-col">
        <div class="day">{{ event?.date | date: 'dd' }}</div>
        <div class="month">{{ event?.date | date: 'MMM' }}</div>
      </div>
    </ion-avatar>

    <!-- Event Info -->
    <ion-grid class="ion-no-padding">
      <ion-label class="ion-wrap">
        <h2
            class="event-name ion-text-nowrap ion-text-bold"
            [style.color]="secondEntryLevel ? mainColor : null"
          >
            {{ event?.name || event?.eventName }}
        </h2>
        <ion-row>
          <ion-col>
            <!-- Date, Strecke, Wertung, Place -->
            <div class="date-range dates dates-nowrap">
              <div *ngIf="event?.date">{{ event?.date | transDate: pipeDateFormat }}</div>
              <div *ngIf="event?.dateFormatted">{{ event?.dateFormatted }}</div>
              <div class="enddate" *ngIf="event?.evtStat">
                - {{ event?.endDate | transDate: pipeDateFormat }}
              </div>
            </div>

            <p class="ion-text-nowrap ion-text-left">
              <ion-icon name="speedometer"></ion-icon>
              {{ event?.streckeconv || event?.strecke }}
            </p>

            <p class="ion-text-nowrap ion-text-left">
              <ion-icon name="pricetag"></ion-icon>
              {{ event?.wertung }}
            </p>

            <p class="ion-text-nowrap ion-text-left" *ngIf="!event?.evtStat">
              <ion-icon name="pin"></ion-icon>
              {{ event?.plz }} {{ event?.place }}
            </p>
          </ion-col>

          <!-- Right Column -->
          <ion-col size="auto" class="align-icon no-padding">
            <p class="ion-text-right" *ngIf="!event?.evtStat">
              {{ event?.date | transDate: 'HH:mm' }} Uhr
            </p>

            <p class="ion-text-right">
              <mysport-icon size="small" [cid]="event?.cid"></mysport-icon>
              {{ event?.cid | categoryName | async | translate }}
            </p>
          </ion-col>
        </ion-row>
      </ion-label>
    </ion-grid>
  </ion-button>



  <ion-item class="item align" *ngIf="secondEntryLevel && !openDetails" (click)="onEventPressed()">

    <ion-avatar slot="start" class="avatar" [class]="order%2==0? 'even': 'odd'">
      <div class="date-range date-range-col">
        <div class="day">{{ event?.date | date: 'dd' }}</div>
        <div class="month">{{ event?.date | date: 'MMM' }}</div>
      </div>
    </ion-avatar>

    <ion-avatar class="image" *ngIf="event?.image">
      <img class="image-opacity" [src]="event?.image.imageLink">
    </ion-avatar>

    <ion-row [ngClass]="{ 'align-top': appDetector.isForestApp() }">
      <div class="content">
        <h4 class="event-name" [style.color]="mainColor" *ngIf="event">
          <strong class="name-event">{{ event?.enaOrig }}</strong>
        </h4>
        <p class="place">{{ event?.place }}</p>
        <div class="dates">
          <div class="date">{{ event?.date | transDate: pipeDateFormat }}-</div>
          <div class="enddate" *ngIf="event.date != event.endDate && event.endDate && event.endDate>0">
            {{ event?.endDate | transDate: pipeDateFormat }}
          </div>
        </div>
      </div>
    </ion-row>
  </ion-item>


</span>
<!-- NEW DESIGN: FINISH -->

<!-- OLD DESIGN: START -->
<span *ngIf="!newDesign && event">
  <ion-button (click)="openEventDetails()" *ngIf="!secondEntryLevel || openDetails" class="transparent-btn">
    <ion-label class="ion-wrap">
    <h2 class="ion-text-nowrap ion-text-bold" *ngIf="!secondEntryLevel">
      {{ event?.name }}
    </h2>

    <h2 class="ion-text-nowrap ion-text-bold" *ngIf="secondEntryLevel" [style.color]="mainColor">
      {{ event?.name || event?.eventName }}
    </h2>
    
    <ion-row>
      <ion-col size="7" class="ion-text-nowrap">
        <p class="ion-text-nowrap ion-text-left">
          <ion-icon name="speedometer"></ion-icon> {{ event?.streckeconv || event?.strecke }}
        </p>
        <p class="ion-text-nowrap ion-text-left">
          <ion-icon name="pricetag"></ion-icon> {{ event?.wertung }}
        </p>
        <p class="ion-text-nowrap ion-text-left" *ngIf="!event?.evtStat">
          <ion-icon name="pin"></ion-icon> {{ event?.plz }} {{ event?.place }}
        </p>
      </ion-col>

      <ion-col size="5">
        <div class="date-range">
          <div *ngIf="event.date">{{ event?.date | transDate: pipeDateFormat }}</div>
          <div *ngIf="event.dateFormatted">{{ event?.dateFormatted }}</div>
          <div style="margin-left:5px" *ngIf="event && event?.evtStat">
            - {{ event?.endDate | transDate: pipeDateFormat }}
          </div>
        </div>

        <p class="ion-text-right" *ngIf="!event?.evtStat">
          {{ event?.date | transDate: 'HH:mm' }} Uhr
        </p>
        <p class="ion-text-right">
          <mysport-icon  size="small" [cid]="event && event?.cid"></mysport-icon>
          {{ event?.cid | categoryName | async | translate }}
        </p>
      </ion-col>
    </ion-row>
  </ion-label>

  </ion-button>


  <ion-item *ngIf="secondEntryLevel && !openDetails && appDetector.isForestApp()" (click)="onEventPressed()">
    <ion-avatar slot="start" *ngIf="event?.image">
      <img [src]="event?.image.imageLink" />
    </ion-avatar>

    <ion-row>
      <h4 class="ion-text-nowrap" [style.color]="mainColor">
        <strong>{{ event?.enaOrig }}</strong>
      </h4>
    </ion-row>

    <ion-row>
      <div class="date-range">
        <div>{{ event?.date | transDate: pipeDateFormat }}</div>
        <div style="margin-left:5px" *ngIf="event?.date != event?.endDate && event?.endDate">
          - {{ event?.endDate | transDate: pipeDateFormat }}
        </div>
      </div>
    </ion-row>

    <ion-row>
      <p style="font-size: 13px;">{{ event?.place }}</p>
    </ion-row>
  </ion-item>

</span>
<!-- OLD DESIGN: FINISH -->